let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ffo3")).then(() => parcelRequire('eV4RC'));